import { render } from "./PatientsDatatableTDName.vue?vue&type=template&id=68bcf84e"
import script from "./PatientsDatatableTDName.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__